/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type Icon83IconProps = React.ComponentProps<"svg"> & {
  title?: string;
};

export function Icon83Icon(props: Icon83IconProps) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 12 12"}
      height={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        fill={"currentColor"}
        fillRule={"evenodd"}
        d={
          "M1 .5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .354.146l3 3A.5.5 0 0 1 11 3.5v8a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5zM2 1v10h8V3.707L7.293 1z"
        }
        clipRule={"evenodd"}
      ></path>

      <path
        fill={"currentColor"}
        fillRule={"evenodd"}
        d={
          "M7.5 0a.5.5 0 0 1 .5.5V3h2.5a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5"
        }
        clipRule={"evenodd"}
      ></path>

      <path fill={"currentColor"} d={"M7.5.5v3h3z"}></path>
    </svg>
  );
}

export default Icon83Icon;
/* prettier-ignore-end */
